import { getMyAccountManagerBrokers } from "@/api/endpoints";
import ActionBtn from '@/components/ActionBtn'
import { ReportContent, ReportHeader, ReportSearch } from '@/components/tableDrawer'
import useNavs from '@/hooks/useNavs';
import { useCallback, useMemo } from 'react'

const ACMBrokers = () => {
  const { AccountManagerNav } = useNavs();

  const viewRequestDetails = useCallback((original) => AccountManagerNav(`medical-reports?brokerId=${original?.id}`), [AccountManagerNav]);

  const columns =  useMemo(() => ([
        { Header: "id", accessor: "id", canSearch: false, visible: true },
        { Header: "brokerName", accessor: "brokerName", canSearch: true, visible: true },
        {Header:"submitedRequestNumber",accessor:"submitedRequestNumber",canSearch:false,visible:true},
        {
        Header: "action",
        Cell: ({ row: { original } }) => (
          <ActionBtn isRender title={"broker-requests"} onApply={()=>viewRequestDetails(original)} className='mx-2' isDisabled={false} />
        ),
      },
    ]),[])

  return (
    <ReportContent columns={columns} stickyActions={true} tableAPI={getMyAccountManagerBrokers} >
        <ReportHeader title={"my-brokers-list"}>
          <ReportSearch />
        </ReportHeader>
      </ReportContent>
  )
}

export default ACMBrokers